var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteEmsLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 216 126",
    style: {
      enableBackground: "new 0 0 216 126"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0aea7f;}\n\t.st1{fill:#00B6F0;}\n\t.st2{fill:#11134A;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "EMSL_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "134.3,92.6 134.3,59.9 129.3,59.9 129.3,97.6 155.6,97.6 155.6,92.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "22.2,59.9 22.2,97.6 48.3,97.6 48.3,92.7 27.2,92.7 27.2,81.3 37.8,81.3 37.8,76.3 27.2,76.3  27.2,64.9 48.3,64.9 48.3,59.9  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M111.8,76.5c-6.2-1.4-12.3-2.1-12.3-6.8c0-5,4.3-6.5,8.6-6.5c4.6,0,8,1.8,9.2,6.1h5 c-1-7.2-6.7-10.4-13.9-10.4c-7,0-13.9,3.4-13.9,11.2c0,7,6.2,8.8,12.3,10.1c6.1,1.3,12.2,2.3,12.2,7.5c0,5.5-5.1,7-9.7,7 c-5.2,0-10.1-2.3-11-7.5h-4.9c0.9,8.1,7.7,11.8,15.7,11.8c7,0,15-3.3,15-11.4C124.1,80.1,118,77.9,111.8,76.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "71.2,77 59.5,59.9 54,59.9 54,97.6 59.1,97.6 59.1,68.2 71.2,85.7 83.2,68.3 83.2,97.6 88.2,97.6  88.2,59.9 82.9,59.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M163.4,32.3c0.6-0.5,1.5-0.8,2.3-0.8c1.1,0,2.1,0.5,2.8,1.3c0.5,0.6,0.8,1.4,0.8,2.2c0,0.1,0,0.3,0,0.4 c-0.1,1-0.6,1.9-1.3,2.5c0,0-0.6,0.6-1.2,1c0.5,0.1,1,0.2,1.5,0.2c3.3,0,6-2.7,6-6c0-3.3-2.7-6-6-6c-3.3,0-6,2.7-6,6 c0,0,0,0.1,0,0.2C162.7,32.8,163.4,32.3,163.4,32.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M184.5,36.8c-5.1,0-9.3,4.2-9.3,9.3c0,1,0.2,2,0.5,2.9c0.8-0.8,2.6-2.8,2.6-2.8c0.7-0.8,1.8-1.3,3-1.3 c1.1,0,2.3,0.4,3.2,1.2c0.9,0.7,1.5,1.7,1.7,2.7c0.3,1.2,0,2.5-0.7,3.4c0,0-1.4,1.9-2.2,3c0.4,0.1,0.9,0.2,1.3,0.2 c5.1,0,9.3-4.2,9.3-9.3C193.8,41,189.6,36.8,184.5,36.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M182.5,48.5c-0.7-0.6-1.6-0.7-2-0.2l-6.2,6.6l-0.3-0.2c-0.6-0.3-1.2-0.6-1.8-0.8c-1.3-0.4-2.7-0.7-4.1-0.7 c-1.4,0-2.7,0.2-4.1,0.7c-0.6,0.2-1.3,0.5-1.8,0.8l-0.3,0.2l-6.1-6.5c-0.2-0.2-0.5-0.3-0.6-0.3c-0.4,0-1,0.1-1.4,0.5 c-0.7,0.6-0.9,1.5-0.6,1.9c0,0,5.3,7.3,5.3,7.3l-0.2,0.3c-0.4,0.5-0.8,1.1-1.1,1.7c-1,1.9-1.6,4-1.6,6.1 c0,6.9,5.7,12.6,12.6,12.6c6.9,0,12.6-5.7,12.6-12.6c0-2.1-0.6-4.3-1.6-6.1c-0.3-0.6-0.7-1.1-1.1-1.7l-0.2-0.3l5.3-7.2 C183.5,50,183.2,49.1,182.5,48.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M149.9,49.9c0-1.3,0.6-2.7,1.8-3.7l0.1-0.1c1-0.7,2-1.1,3.1-1.1c1,0,1.9,0.3,2.6,0.9c0,0,0.4,0.4,0.4,0.4 s1.7,1.8,2.6,2.7c0.3-0.9,0.5-1.9,0.5-2.9c0-1-0.2-2-0.5-2.9c-0.2-0.6-0.5-1.2-0.8-1.8l-0.1-0.2c0.7-0.6,6.2-5.3,6.5-5.6 c0.4-0.3,0.3-0.8,0.2-1c-0.1-0.2-0.3-0.3-0.6-0.3c-0.3,0-0.6,0.2-0.9,0.5c-0.2,0.2-5.9,4.3-6.4,4.8l-0.2-0.2 c-0.5-0.4-1-0.8-1.6-1.2c-1.5-0.9-3.1-1.3-4.8-1.3c-5.1,0-9.3,4.2-9.3,9.3c0,5.1,4.2,9.3,9.3,9.3c0.4,0,0.8-0.1,1.3-0.2 c-0.7-0.9-2.2-3-2.2-3C150.2,51.6,149.9,50.8,149.9,49.9"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteEmsLogo);
export default __webpack_public_path__ + "static/media/White_EMS_ logo.765caa53a487f9d7dcb0ef56a34a5d0b.svg";
export { ForwardRef as ReactComponent };